const UNAVAILABLE_MESSAGE = { paymentStatus: 'UNAVAILABLE' };
const CLOSE_MESSAGE = { isIframePayment: true };
const OWN_HEADER_MESSAGE = { paymentFormHeader: 'shown' };

const isEmbedded = (): boolean => window.top !== window.self;

/**
 * The form is rendered inside an iframe of the product, which listens for
 * these messages (RedirectDepositModal) and handles the navigation itself.
 * Returns false when the form is opened as a standalone page.
 */
const postToProduct = (message: Record<string, unknown>): boolean => {
  if (!isEmbedded() || !window.top) {
    return false;
  }

  window.top.postMessage(message, '*');

  return true;
};

/** Back to the first step of the deposit flow - the payment method list. */
export function goToPaymentMethods(): void {
  if (!postToProduct(UNAVAILABLE_MESSAGE)) {
    window.history.back();
  }
}

/** Close the payment flow and go to the casino main page. */
export function goToCasinoHome(): void {
  if (!postToProduct(CLOSE_MESSAGE)) {
    window.location.assign('/');
  }
}

/**
 * Tell the product that the form renders its own header (back arrow, title,
 * close button), so the product can hide its duplicate controls around the iframe.
 */
export function notifyOwnHeaderShown(): void {
  postToProduct(OWN_HEADER_MESSAGE);
}
